import styled from "styled-components";
import { EditorTheme } from "./CodeEditor/EditorConfig";

export default styled.div<{ theme?: EditorTheme }>`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: transparent;
  pointer-events: none;
  z-index: 10;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
`;
